import {createAction, props} from "@ngrx/store";

export const getMetasInfos = createAction(
    '[currentPub] get meta informations',
    props<{ pubUuid: string, comId: number }>(),
);
export const getMetasInfosSuccess = createAction(
    '[currentPub] get meta informations success',
    props<{ infos: any, extProfilsNeeded: any }>(),
);

export const evaluateRules = createAction(
    '[currentPub] Evaluate rules'
);
export const evaluateRulesSuccess = createAction(
    '[currentPub] Evaluate rules success'
);
// export const getMetasInfosSuccess = createAction(
//     '[currentPub] get meta informations success',
//     props<{ infos: any, extProfilsNeeded: any }>(),
// );


export const geoLocateUser = createAction(
    '[currentPub] get user location info',
);
export const geoLocateUserSuccess = createAction(
    '[currentPub] get user location info success',
);
